import { useCallback, useEffect, useRef } from "react";

export const useOAuthPopup = ({ onSuccess = () => {} }) => {
  const popupRef = useRef(null);

  const openPopup = useCallback((authUrl) => {
    // Prevent duplicate popups
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.focus();
      return;
    }

    const width = 700;
    const height = 600;

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const popup = window.open(
      authUrl,
      "oauthPopup",
      `width=${width},height=${height},left=${left},top=${top}`,
    );

    if (!popup) {
      window.location.href = authUrl; // fallback
      return;
    }

    popupRef.current = popup;
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel("oauth_channel");

    channel.onmessage = (event) => {
      if (event.data?.type !== "SQUARE_OAUTH") return;

      const callbackUrl = event.data.url;
      popupRef.current?.close();
      popupRef.current = null;

      onSuccess?.();
      if (callbackUrl) window.location.href = callbackUrl;
    };

    return () => channel.close();
  }, [onSuccess]);

  return { openPopup };
};
